import { render, staticRenderFns } from "./dictEditor.vue?vue&type=template&id=1e9604d9"
import script from "./dictEditor.vue?vue&type=script&lang=js"
export * from "./dictEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports